const transformBrandName = (brandName) => {
  // eslint-disable-next-line eqeqeq
  if (brandName == undefined || brandName?.toLowerCase() === 'unbranded') {
    return '';
  }
  return brandName;
}

export { transformBrandName };